import React, {useState} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
} from "../../atom/Apollo_styles";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloUserProfileAuth} from "../../atom/Apollo_Authorization";
import {
  accountgroupedit_path,
  apollo_approval_accountgroup_path,
  apollo_accountgroups_path,
  accountgroups_path,
} from "../../atom/Apollo_links";
import {AccountGroup, ApolloAccountApprove} from "../../organism/ACCOUNT/AccountModel";

import {CustomizedSnackbars} from "../../atom/Apollo_Mesasge"
import {Link, useHistory} from "react-router-dom";

import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import {ApolloContext} from "../../atom/Apollo_Context";
import Tooltip from '@material-ui/core/Tooltip';
import { useEffect } from "react";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";

import {useLocation} from "react-router-dom";

import {ApolloTabPanel,ApolloTabs} from "../../atom/Apollo_Tabs"
import ApolloAccountGroupList from "../../organism/ACCOUNT/Apollo_AccountGroupList";
import ApolloUnapprovedAccountList from "../../organism/ACCOUNT/Apollo_UnapprovedAccountList";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_GROUP_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

/*
    画面名：アカウントグループ一覧画面
 */
const AccountGroupPage: React.FC = () => {
  const history = useHistory();
  const classes = apollo_useStyles();
  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [rows, setRows] = useState<AccountGroup[]>([]);
  const [accountRows, setAccountRows] = useState<ApolloAccountApprove[]>();
  const [tabstate, setTabstate] = useState(0);
  const tablabel= [ "アカウントグループ","未承認アカウント" ]

  // アカウント詳細画面からの戻りのためクエリをチェックする
  const query1 = new URLSearchParams(useLocation().search);
  const queryType = query1.has("type") ? query1.get("type") : "";

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 9,
    breadId: 1,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const setPage = () => {
    if (queryType === "ap") {
      // type="ap"で未承認一覧に遷移するためtabstateに1をセットしURLからtype="ap"を削除
      setTabstate(1);
      history.push(accountgroups_path);
    }
  }

  useEffect(() => {
    // クエリチェック
    setPage();

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });

    if( tabstate === 0 ) {
      const url = apollo_accountgroups_path;
      ApolloAxios.get(url).then(response => {
        if (response.data.resultCode === 0) {
          setRows(response.data.result);
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false,
            }
          });
        } else {
          console.log(response.data.message);
          setmsg({
            type: "all",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_GROUP_LIST,"E","0"),
              loading: false,
            }
          });
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_GROUP_LIST,"E","0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
        // if (err.redirecturl !== "") {
        //   const url = err.redirect + history.location.pathname;
        //   history.push( url );
        // }
      });
    } else if( tabstate === 1 ) {
      const url = apollo_approval_accountgroup_path + "/" + state.current.accountGroupId ;
      ApolloAxios.get(url).then(response => {
        if (response.data.resultCode === 0) {
          setAccountRows(response.data.result);
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false,
            }
          });
        } else {
          console.log(response.data.message);
          setmsg({
            type: "all",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_GROUP_LIST,"E","1"),
              loading: false,
            }
          });
        }
      }).catch(err => {
        console.log(err)
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_GROUP_LIST,"E","1"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
        // if (err.redirecturl !== "") {
        //   const url = err.redirect + history.location.pathname;
        //   history.push( url );
        // }
      });
    }
  }, [tabstate]);

  return (
    <GenericTemplate title="">
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <ApolloTabs value={tabstate} setValue={setTabstate} tablabel={tablabel}/>
      <ApolloTabPanel value={tabstate} index={0}>
        <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
          <Tooltip title="アカウントグループ作成" placement="bottom">
            <Link to={accountgroupedit_path + "0"} className={classes.link}>
              <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                <AddIcon/>
              </Fab>
            </Link>
          </Tooltip>
        </ApolloUserProfileAuth>
        <ApolloAccountGroupList rows={rows}/>
      </ApolloTabPanel>
      <ApolloTabPanel value={tabstate} index={1}>
        <ApolloUnapprovedAccountList rows={accountRows} setTabstate={setTabstate}/>
      </ApolloTabPanel>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default AccountGroupPage;
